import PropTypes from 'prop-types';

const WhyCard = ({ icon: Icon, title, delay = 0 }) => {
  return (
    <div
      className="col-lg-3 col-md-6 mb-4"
      data-aos="fade-up"
      data-aos-delay={delay}
    >
      <div className="edu-card p-4">
        <div className="icon">
          <Icon />
        </div>
        <h4 className="title">{title}</h4>
      </div>
    </div>
  );
};

WhyCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  delay: PropTypes.number,
};

export default WhyCard;
